import { Container, TableButton } from "@fluidattacks/design";
import { useCallback } from "react";
import type { FormEvent } from "react";

import type { IPlusFormatterProps } from "../types";
import { translate } from "utils/translations/translate";

const PlusFormatter = ({
  cell,
  plusFunction,
}: IPlusFormatterProps): JSX.Element => {
  const { row } = cell;

  const handlePlusFormatter = useCallback(
    (event: FormEvent<HTMLButtonElement>): void => {
      event.stopPropagation();
      plusFunction(row.original);
    },
    [row, plusFunction],
  );

  return (
    <Container alignItems={"center"} display={"flex"} gap={0.5}>
      <TableButton
        id={"add-repository"}
        onClick={handlePlusFormatter}
        variant={"add"}
      />
      {translate.t("organization.tabs.weakest.formatter.plus.button")}
    </Container>
  );
};

export { PlusFormatter };
